// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__r6udK","messages":"Chat_messages__3srq6","dateDivider":"Chat_dateDivider__1Zb5x"};